import { appLanguageSwitcherModel } from "@/shared/components/app-language-switcher/app-language-switcher.model";
import { AppLanguageCode } from "@/shared/i18n/translations";
import { staticLib } from "@public/js/static-lib.js";
import { watch, WatchStopHandle } from "vue";
import { Vue } from "vue-property-decorator";

const tl = staticLib.gsap.timeline();

export const appFallbackLang = AppLanguageCode.en;

export class AppLanguageSwitcherComponent extends Vue {
    declare $refs: {
        switcher: HTMLDivElement;
        innerSwitcher: HTMLDivElement;
    };

    model = appLanguageSwitcherModel;

    disposers: WatchStopHandle[] = [];

    AppLanguageCode = AppLanguageCode;

    mounted() {
        this.disposers.push(
            watch(
                () => ({ isActive: this.model.active }),
                ({ isActive }) => {
                    // Adopted from static/src/js/components/lang-switcher.js
                    const dropdownPosition =
                        this.$refs.innerSwitcher.getBoundingClientRect();
                    const dropdownRight = dropdownPosition.x + dropdownPosition.width;

                    if (dropdownRight > window.innerWidth) {
                        const diff =
                            window.innerWidth -
                            dropdownRight -
                            (staticLib.isTouch() ? 12 : 30);

                        tl.to(this.$refs.switcher, {
                            duration: 0.8,
                            x: diff,
                            ease: "power4.out",
                        });
                    }

                    if (!isActive) {
                        tl.to(this.$refs.switcher, {
                            duration: 0.8,
                            x: 0,
                            ease: "power4.out",
                        });
                    }
                },
            ),
        );
    }

    unmounted() {
        this.disposers.forEach((disposer) => disposer());
    }
}
